import React, { ChangeEvent } from 'react'
import { useClientLeverageLimit } from './hooks'
import {
  CButton,
  CCol,
  CForm,
  CFormCheck,
  CFormSelect,
  CHeaderText,
  CRow,
} from '@coreui/react-pro'
import { setClientLeverageLimit, submitClientLeverageLimit } from './model'
import { leverages } from '../../../../../../libs/leverages'

export const AccountSettingsForm = () => {
  const { accountForm, loading, clientLeverageLimitError } =
    useClientLeverageLimit()

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value

    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }

    setClientLeverageLimit({
      ...accountForm,
      [event.currentTarget.name]: value,
    })
  }

  return (
    <CForm className="p-3">
      <CHeaderText className="fw-bold fs-2">Accounts settings</CHeaderText>
      <CRow className="mb-3">
        {clientLeverageLimitError.code !== 0 && (
          <div className="mt-2 text-danger">
            {`Error: ${clientLeverageLimitError.message}`}
          </div>
        )}
      </CRow>
      <CRow className="mb-3">
        <CCol sm={12}>
          <CFormSelect
            label="leverage limit"
            name="leverage"
            placeholder={'Choose leverage'}
            value={accountForm.leverage}
            onChange={handleChange}
          >
            <option>Choose leverage</option>
            {leverages.map((item) => (
              <option value={item.value}>{item.text}</option>
            ))}
          </CFormSelect>
        </CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol sm={12}>
          <CFormCheck
            label="Update all active accounts"
            name="isUpdateAccounts"
            checked={accountForm.isUpdateAccounts}
            onChange={handleChange}
          ></CFormCheck>
        </CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol sm={12}>
          <CFormCheck
            label="Update the leverage to the maximum available, taking into account the limitation"
            name="isChangeMTLeverage"
            checked={accountForm.isChangeMTLeverage}
            onChange={handleChange}
          ></CFormCheck>
        </CCol>
      </CRow>
      <CRow className="mb-3">
        <CCol sm={8} className="d-flex justify-content-end">
          <CButton
            className="mb-3 text-right w-50"
            disabled={loading || !accountForm.leverage}
            onClick={() =>
              submitClientLeverageLimit({
                ...accountForm,
                leverage: accountForm.leverage,
                isUpdateAccounts: accountForm.isUpdateAccounts,
                isChangeMTLeverage: accountForm.isChangeMTLeverage,
              })
            }
          >
            {loading && (
              <span className="spinner-border spinner-border-sm"></span>
            )}
            Save
          </CButton>
        </CCol>
      </CRow>
    </CForm>
  )
}
